import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';

import { OverlayContainer } from '../shared.styles';

// TODO: temporary until overlay changes are broader, probably HL-1669
const Overlay = styled(OverlayContainer)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  text-align: center;
  background: ${props => props.theme.COLOR.GREY.WHITE};
`;

const noop = () => {
  return;
};

const OverlayContext = createContext<{
  showOverlay: (overlay: ReactNode) => void;
  hideOverlay: () => void;
  overlay: Nullable<ReactNode>;
}>({
  showOverlay: noop,
  hideOverlay: noop,
  overlay: null,
});

export const OverlayProvider = ({ children }: { children: ReactNode }) => {
  const [overlay, setOverlay] = useState<Nullable<ReactNode>>(null);
  const overlayRef = useRef<HTMLDivElement>(null);

  const showOverlay = useCallback((overlay: Nullable<ReactNode>) => {
    setOverlay(<Overlay ref={overlayRef}>{overlay}</Overlay>);
  }, []);

  const hideOverlay = useCallback(() => setOverlay(null), []);

  useEffect(() => {
    if (overlayRef?.current) {
      disableBodyScroll(overlayRef.current as unknown as HTMLElement);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [overlay]);

  return (
    <OverlayContext.Provider value={{ overlay, showOverlay, hideOverlay }}>
      {children}
    </OverlayContext.Provider>
  );
};

export const useOverlay = () => useContext(OverlayContext);
